import moment from 'moment'
import { getUrlParameter } from '@helpers'

// Bug 8003: a chave estável de um link de campanha é origem + destino + data,
// não o id de catálogo. O id de catálogo (`loc_city_<guid>` na MuviHub,
// numérico no legado) é opaco e específico de cada catálogo/ambiente - por
// isso NUNCA é convertido para número aqui (parseInt quebrava qualquer id não
// numérico, transformando-o em NaN e invalidando o link inteiro). Nome
// (Origem/Destino, com fallback para os parâmetros legados OriginCity/
// DestinoCity) e IBGE (IdOrigemIBGE/IdDestinoIBGE) são lidos como alternativa
// ao id para quem for resolver o link (ver search-form.component.jsx).
function getTripParams() {
	let tripDateGoing = getUrlParameter('DataIda', '')
	const tripDateReturn = getUrlParameter('DataVolta', null)
	const originPortal = getUrlParameter('PortalOrigem', 'SiteMuviflex')
	const originId = getUrlParameter('IdOrigem', '')
	const destinationId = getUrlParameter('IdDestino', '')
	const originName = getUrlParameter('Origem', '') || getUrlParameter('OriginCity', '')
	const destinationName = getUrlParameter('Destino', '') || getUrlParameter('DestinoCity', '')
	const originIbge = getUrlParameter('IdOrigemIBGE', '')
	const destinationIbge = getUrlParameter('IdDestinoIBGE', '')
	const destinationBusCompany = getUrlParameter('Empresa', 'Planalto')
	const raceDate = getUrlParameter('raceDate', '')
	const hasChildren = getUrlParameter('hasChildren', false)
	const campaignCode = getUrlParameter('CampaignCode', '')

	if (tripDateGoing && new Date(tripDateGoing) < new Date()) {
		tripDateGoing = moment().format('YYYY-MM-DD')
	}

	const isValidParameters =
		!!tripDateGoing &&
		!!(originId || originName) &&
		!!(destinationId || destinationName)

	const response = {
		tripDateGoingSearch: tripDateGoing,
		tripDateReturnSearch:
			tripDateReturn && tripDateReturn !== 'null' ? tripDateReturn : null,
		originPortal,
		originId,
		destinationId,
		originName,
		destinationName,
		originIbge,
		destinationIbge,
		destinationBusCompany,
		raceDate,
		isValidParameters,
		hasChildren,
		campaignCode,
	}

	return response
}

export default getTripParams

export const iFrameHelper = {
	getTripParams,
}
